/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamPermission,
    IamPermissionFromJSON,
    IamPermissionFromJSONTyped,
    IamPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetIamPermissionResponse
 */
export interface GetIamPermissionResponse {
    /**
     * 
     * @type {IamPermission}
     * @memberof GetIamPermissionResponse
     */
    iamPermission?: IamPermission;
}

export function GetIamPermissionResponseFromJSON(json: any): GetIamPermissionResponse {
    return GetIamPermissionResponseFromJSONTyped(json, false);
}

export function GetIamPermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIamPermissionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamPermission': !exists(json, 'iam_permission') ? undefined : IamPermissionFromJSON(json['iam_permission']),
    };
}

export function GetIamPermissionResponseToJSON(value?: GetIamPermissionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_permission': IamPermissionToJSON(value.iamPermission),
    };
}


